import styled, { css } from 'styled-components'

import { ReactComponent as SquareBorderAllIcon } from '@sketch/icons/square-border-all-17'
import { ReactComponent as SquareBorderTopIcon } from '@sketch/icons/square-border-top-17'
import { ReactComponent as SquareBorderRightIcon } from '@sketch/icons/square-border-right-17'
import { ReactComponent as SquareBorderBottomIcon } from '@sketch/icons/square-border-bottom-17'
import { ReactComponent as SquareBorderLeftIcon } from '@sketch/icons/square-border-left-17'

const iconStyles = css`
  width: 17px;
  height: 17px;
  opacity: 50%;
  margin-right: 6px; /* stylelint-disable-line scales/space */
`

export const AllSidesIcon = styled(SquareBorderAllIcon)`
  ${iconStyles}
`
export const TopSideIcon = styled(SquareBorderTopIcon)`
  ${iconStyles}
`
export const RightSideIcon = styled(SquareBorderRightIcon)`
  ${iconStyles}
`
export const BottomSideIcon = styled(SquareBorderBottomIcon)`
  ${iconStyles}
`
export const LeftSideIcon = styled(SquareBorderLeftIcon)`
  ${iconStyles}
`

export const PerSideBorderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const PerSideValue = styled.div<{ $dimmed?: boolean }>`
  display: flex;
  align-items: center;
  flex: 0 1 50%;
  margin-top: 3px; /* stylelint-disable-line scales/space */

  ${({ $dimmed }) =>
    $dimmed &&
    css`
      opacity: 0.35;
    `}
`

export const Capitalized = styled.span`
  text-transform: capitalize;
`
